window._ = require('lodash');

try {
    require('bootstrap');
    window.$ = window.jQuery = require('jquery');
    /*window.steps = require('jquery-steps/build/jquery.steps');*/
    window.Cookies = require('js-cookie');
    window.swal = require('sweetalert2/dist/sweetalert2.all.min');
    window.slick = require('slick-carousel/slick/slick');
    require('chosen-js/chosen.jquery.min')
    require('jquery-ui/ui/widgets/autocomplete')
    require('jquery-ui/ui/widgets/datepicker')
    require('jquery-ui/ui/widgets/sortable')
    require('datatables.net-dt')();
    require('datatables.net-responsive-dt');
    require('jquery-ui/ui/widgets/autocomplete');
    const Quagga = require('quagga').default;
} catch (e) {
}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     forceTLS: true
// });
